import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form } from "antd";
import { List } from "immutable";
import _capitalize from "lodash/capitalize";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { OrderedMap } from "immutable";
import { ADDRESSES_TYPES, RESIDENCE_TYPES } from "constants/enums";
import { INPUT_TYPES } from "constants/input-types";
import CompanyService from "services/company-service";
import moment from "moment";
import "styles/form.css";

const AddressOptions = ADDRESSES_TYPES.map((value, label) => ({
    value,
    label
}))
    .toList()
    .toArray();

const permanentAddressValue = (value) => {
    console.log("inside permanentAddressValue", value);
    return value;
};   

const ADDRESS_FIELDS = new OrderedMap({
    checkbox_permanent_address: {
        className: "form-field",
        label: "Same as residence address",
        type: INPUT_TYPES.CHECKBOX,
    },
    address_type: {
        className: "form-field",
        label: "Address Type",
        placeholder: "Registered Office",
        type: INPUT_TYPES.SELECT,
        options: AddressOptions
    },
    ownership_type: {
        className: "form-field",
        type: INPUT_TYPES.SELECT,
        label: "Ownership",
        placeholder: "Rented",
        options: RESIDENCE_TYPES.map((value, key) => ({
            label: key,
            value
        })).toList(),
        rules: [
            {
                required: true,
                message: "Residence ownership is required"
            }
        ]
    },
    residing_since: {
        className: "form-field",
        label: "Residing since",
        type: INPUT_TYPES.DATE_MONTH,
        placeholder: "Residing since",
        disabledDate: current => {
            return current && current > moment();
        },
        // rules: [
        //     {
        //         required: true,
        //         message: "Residing date is required"
        //     }
        // ]
    },
    address_line_1: {
        className: "form-field",
        label: "Address Line 1",
        icon: "address",
        placeholder: "House No., Building",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                max: 128,
                message: "Please Enter address of length less than 128"
            }
        ]
    },
    address_line_2: {
        className: "form-field",
        label: "Address Line 2",
        icon: "address",
        placeholder: "Street, Area",
        type: INPUT_TYPES.TEXT,
        rules: [
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                max: 128,
                message: "Please Enter address of length less than 128"
            }
        ]
    },
    pincode: {
        className: "form-field",
        label: "Pincode",
        placeholder: "123000",
        type: INPUT_TYPES.TEXT,
        rules: [ 
            {
                required: true,
                message: "Field is mandatory"
            },
            {
                //eslint-disable-next-line
                pattern: "^[1-9][0-9]{5}$",
                message: "Enter valid Pincode"
            }
        ]
    },
    city: {
        className: "form-field",
        label: "City",
        icon: "environment",
        placeholder: "Delhi",
        type: INPUT_TYPES.OBJECT_SELECT,
        labelProp: "name",
        showSearch: true,
        rules: [
            {
                required: true,
                message: "Field is mandatory"
            }
        ],
        onSearch: (str) => {
            return str && str.length > 0
                ? CompanyService.locationLookup({
                    ["city_name"]: str
                }).then(({ data }) => {
                    if(!data || !data.length) {
                        return {
                            data: [{
                                id: null,
                                name: _capitalize(str)
                            }]
                        };
                    }
                    return {
                        data: new List(data).toMap().mapKeys((k, _) => _.name).toList().toArray()
                    };
                })
                : Promise.resolve({
                    data: []
                });
        },
    },
    district: {
        className: "form-field",
        label: "District",
        icon: "environment",
        placeholder: "Delhi",
        type: INPUT_TYPES.OBJECT_SELECT,
        labelProp: "name",
        showSearch: true,
        // rules: [
        //     {
        //         required: true,
        //         message: "Field is mandatory"
        //     }
        // ],
        onSearch: (str) => {
            return str && str.length > 0
                ? CompanyService.getDistrictList(
                    str
                ).then(({ data }) => {
                    if(!data || !data.results.length) {
                        return {
                            data: [{
                                id: null,
                                name: _capitalize(str)
                            }]
                        };
                    }
                    return {
                        data: new List(data.results).toMap().mapKeys((k, _) => _.name).toList().toArray()
                    };
                })
                : Promise.resolve({
                    data: []
                });
        },
    },
    state: {
        className: "form-field",
        label: "State",
        icon: "environment",
        placeholder: "Delhi",
        type: INPUT_TYPES.OBJECT_SELECT,
        showSearch: true,
        labelProp: "name",
        rules: [
            {
                required: true,
                message: "Field is mandatory"
            }
        ],
        onSearch: str => {
            return str && str.length > 0
                ? CompanyService.locationLookup({
                    ["state_name"]: str
                }).then(({ data }) => ({
                    data: new List(data)
                        .toMap()
                        .mapKeys((k, _) => _.name)
                        .toList()
                        .toArray()
                }))
                : Promise.resolve({
                    data: []
                });
        }
    },
    is_communication_address: {
        className: "form-field",
        label: "Is Communication Address",
        // placeholder: "Yes",
        type: INPUT_TYPES.RADIO,
        defaultValue: false,
        options: [
            {
                key: "Yes",
                value: true,
                label: "Yes"
            },
            {
                key: "No",
                value: false,
                label: "No"
            }
        ]
    }
});

class AddAddressForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    state={
        permanentAddressCheck : false,
    }
    enhanceFormFields = () =>{
        console.log("ADDRESS_FIELDS", ADDRESS_FIELDS.toJS().address_type);
        return (ADDRESS_FIELDS.setIn(
            ["address_type", "disabled"],
            this.props.addressTypes && this.props.addressTypes.length === 0
        ).setIn(
            ["address_type", "options"],
            AddressOptions.filter(_ =>
                this.props.addressTypes && this.props.addressTypes.length > 0
                    ? this.props.addressTypes.includes(_.value)
                    : true
            )
        ));};
    fields = this.enhanceFormFields();
    onChange = () => {
        this.setState({permanentAddressCheck:!this.state.permanentAddressCheck});
        permanentAddressValue(!this.state.permanentAddressCheck);
        this.props && this.props.sameAddressCallback && this.props.sameAddressCallback(!this.state.permanentAddressCheck);
    };
    render() {
        let fieldsResidenceAddress =  this.fields.toJS().address_type &&  this.fields.toJS().address_type.options && this.fields.toJS().address_type.options[0] && this.fields.toJS().address_type.options[0].label === "Residence";
        // let appearedField = this.fields.toJS() && Object.keys(this.fields.toJS()).filter(el=> el !== "checkbox_permanent_address");
        return (
            <Form
                layout="vertical"
                hideRequiredMark={false}
                className={cx("form", "br-3")}>
                {this.fields
                    .map((field, fieldName) => {
                        if(fieldName === "district") {
                            let city = this.props.form.getFieldValue("city");
                            if(city && !city.id) {
                                field.disabled = false;
                                field.rules = [
                                    {
                                        required: true,
                                        message: "Field is mandatory"
                                    }
                                ];
                            } else {
                                field.disabled = true;
                                field.rules = [];
                            }

                            if(city && city.id){
                                field.disabled = false;
                            }
                        }
                        if(fieldsResidenceAddress && fieldName === "checkbox_permanent_address" ){
                            return false;
                        }
                        if(fieldName ==="address_type"){
                            console.log("address_type", field.options[0] && field.options[0].label === "Permanent");
                            
                        }
                        if(fieldName === "checkbox_permanent_address"){
                            field.onChange = this.onChange;
                            field.checked = this.state.permanentAddressCheck;
                        }
                        return this.fieldGenerator(
                            fieldName,
                            field,
                            this.getErrorOnField(fieldName)
                        )();
                    })
                    .toList()}
            </Form>
        );
    }
}

AddAddressForm.propTypes = {
    values: PropTypes.object,
    form: PropTypes.object,
    addressTypes: PropTypes.array,
    testCheckbox: PropTypes.string,
    sameAddressCallback: PropTypes.func
};

export default Form.create({
    mapPropsToFields: ({ values }) =>
        values &&
        values
            .toSeq()
            .toMap()
            .map((value, key) => {
                if (key === "residing_since") {
                    return Form.createFormField({
                        value: !value ? !value ||  isNaN(value.date()) ? null : value : moment(value)
                    });
                }
                return Form.createFormField({
                    value
                });
            })
            .toJS()
})(AddAddressForm);
